"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _host = require("../../host");
var _utils = require("../../../utils/utils");
var _ = require("../..");
var _constants = require("../../../utils/constants");
var _productCatalogUtil = require("../../../utils/productCatalogUtil");
class HostServiceCL extends _host.HostService {
  constructor(_ref) {
    let {
      hostMarketingId,
      hostAddToCartCallback,
      config,
      openGuidedSellingModal
    } = _ref;
    super({
      hostMarketingId,
      hostAddToCartCallback,
      config,
      openGuidedSellingModal
    });
    this.MODEL_NAME_PREFIX = 'h';
    /* Routes that uses the remote window function */
    this.WINDOW_FUNC_ROUTES = ['miportal.entel.cl', 'portalpreprod.entel.cl', 'ociportalpreprod.entel.cl'];
  }
  getMarketingId() {
    var _window$guidedSelling;
    if (typeof ((_window$guidedSelling = window.guidedSelling) === null || _window$guidedSelling === void 0 ? void 0 : _window$guidedSelling.marketingId) !== 'function') {
      return super.getMarketingId();
    }
    return window.guidedSelling.marketingId();
  }
  isUserCustomer(metadata) {
    var _metadata$flags, _metadata$flags2, _metadata$flags3, _metadata$flags4;
    return (metadata === null || metadata === void 0 ? void 0 : (_metadata$flags = metadata.flags) === null || _metadata$flags === void 0 ? void 0 : _metadata$flags[_constants.FLAGS.IS_CUSTOMER]) || (metadata === null || metadata === void 0 ? void 0 : (_metadata$flags2 = metadata.flags) === null || _metadata$flags2 === void 0 ? void 0 : _metadata$flags2[_constants.FLAGS.NEW_CUSTOMER]) && (metadata === null || metadata === void 0 ? void 0 : (_metadata$flags3 = metadata.flags) === null || _metadata$flags3 === void 0 ? void 0 : _metadata$flags3[_constants.FLAGS.BOTH_FLOW]) && (metadata === null || metadata === void 0 ? void 0 : (_metadata$flags4 = metadata.flags) === null || _metadata$flags4 === void 0 ? void 0 : _metadata$flags4[_constants.FLAGS.NEXT_FLOW]);
  }
  getPlanQty(planProductObj, appMetadata) {
    var _appMetadata$flags;
    let plansNums = (planProductObj === null || planProductObj === void 0 ? void 0 : planProductObj.additionalPlans) + 1;
    if (appMetadata !== null && appMetadata !== void 0 && (_appMetadata$flags = appMetadata.flags) !== null && _appMetadata$flags !== void 0 && _appMetadata$flags.isCustomer) plansNums = planProductObj === null || planProductObj === void 0 ? void 0 : planProductObj.additionalPlans;
    plansNums = plansNums || 1;
    return plansNums;
  }
  async composePlanPayload(_ref2) {
    var _this$config$maximumA, _costs, _costs2, _entelPlanPaser$getTe, _entelPlanPaser$getTe2, _costs3, _costs4, _costs5, _costs5$plan, _costs6, _appMetadata$flags2, _costs7, _costs8, _appMetadata$flags3, _appMetadata$flags4;
    let {
      planProduct,
      appMetadata,
      costs
    } = _ref2;
    const planProductObj = {
      ...planProduct
    };
    const maximumAdditionalPlans = (_this$config$maximumA = this.config.maximumAdditionalPlans) !== null && _this$config$maximumA !== void 0 ? _this$config$maximumA : 3;
    const entelPlanPaser = new _.Parsers.AdditionalPlanParser(planProductObj, planProductObj.additionalPlans, maximumAdditionalPlans);
    let plansNums = this.getPlanQty(planProductObj, appMetadata);

    // Default plan in case of additional plan flow
    const {
      DefaultPlan
    } = this.config;
    if (!((_costs = costs) !== null && _costs !== void 0 && _costs.termDuration) && !((_costs2 = costs) !== null && _costs2 !== void 0 && _costs2.totalTermCost) && DefaultPlan !== null && DefaultPlan !== void 0 && DefaultPlan.PlanId) {
      var _totalPrice$price, _totalPriceAfterDisco, _totalPrice$productOf, _totalPrice$productOf2, _totalPrice$productOf3;
      if (!costs) costs = {};
      const defaultPlanRes = await (0, _productCatalogUtil.getProductOfferingById)(`${DefaultPlan.PlanId}-PLANS1`);
      const prices = defaultPlanRes === null || defaultPlanRes === void 0 ? void 0 : defaultPlanRes.productOfferingPrice;
      const totalPrice = prices === null || prices === void 0 ? void 0 : prices.find(p => p.priceType === _constants.PRICE_TYPES.LIST_ADDITIONAL_PLAN_PRICE);
      const totalPriceAfterDiscount = prices === null || prices === void 0 ? void 0 : prices.find(p => p.priceType === _constants.PRICE_TYPES.COMMERCE_ADDITIONAL_PLAN_PRICE);
      planProductObj.productId = defaultPlanRes.id;
      planProductObj.productName = defaultPlanRes.name;
      costs.totalTermCost = (totalPrice === null || totalPrice === void 0 ? void 0 : (_totalPrice$price = totalPrice.price) === null || _totalPrice$price === void 0 ? void 0 : _totalPrice$price.value) || DefaultPlan.PlanPrice * plansNums;
      costs.totalTermCostAfterDiscount = (totalPriceAfterDiscount === null || totalPriceAfterDiscount === void 0 ? void 0 : (_totalPriceAfterDisco = totalPriceAfterDiscount.price) === null || _totalPriceAfterDisco === void 0 ? void 0 : _totalPriceAfterDisco.value) || DefaultPlan.PlanPriceBeforeDiscount * plansNums;
      costs.termDuration = (totalPrice === null || totalPrice === void 0 ? void 0 : (_totalPrice$productOf = totalPrice.productOfferingTerm) === null || _totalPrice$productOf === void 0 ? void 0 : (_totalPrice$productOf2 = _totalPrice$productOf[0]) === null || _totalPrice$productOf2 === void 0 ? void 0 : (_totalPrice$productOf3 = _totalPrice$productOf2.duration) === null || _totalPrice$productOf3 === void 0 ? void 0 : _totalPrice$productOf3.amount) || 6;
    }
    return {
      /** digits indicating percentage of discount. For example, 25 */
      porcentajeDscto: (_entelPlanPaser$getTe = entelPlanPaser.getTexts) === null || _entelPlanPaser$getTe === void 0 ? void 0 : (_entelPlanPaser$getTe2 = _entelPlanPaser$getTe.discountAmount) === null || _entelPlanPaser$getTe2 === void 0 ? void 0 : _entelPlanPaser$getTe2.toString(),
      /** text indicating plan’s name. For example, Plan 120GB */
      nombrePlan: planProductObj.productName,
      /** digits indicating inicial Price of the plan. For example, 8993 */
      valorIniPlan: Math.round(((_costs3 = costs) === null || _costs3 === void 0 ? void 0 : _costs3.totalTermCostAfterDiscount) / plansNums).toString(),
      /** digits indicating later Price of the plan. For example, 11990 */
      valorFinPlan: Math.round(((_costs4 = costs) === null || _costs4 === void 0 ? void 0 : _costs4.totalTermCost) / plansNums).toString(),
      /** digits indicating normal Price of the plan. For example, 11990 */
      valorNormal: Math.round(((_costs5 = costs) === null || _costs5 === void 0 ? void 0 : (_costs5$plan = _costs5.plan) === null || _costs5$plan === void 0 ? void 0 : _costs5$plan.termCost) || ((_costs6 = costs) === null || _costs6 === void 0 ? void 0 : _costs6.totalTermCost) / plansNums).toString(),
      /** digit indicating amount of lines. For example, 1 */
      cantidadLineas: plansNums.toString(),
      /** for example, PO_POS_OO_15576 */
      planId: planProductObj.productId.replace(/-PLANS(\d+)/, ''),
      /** text indicating type of contract. For example, nuevo */
      modContratacion: appMetadata !== null && appMetadata !== void 0 && (_appMetadata$flags2 = appMetadata.flags) !== null && _appMetadata$flags2 !== void 0 && _appMetadata$flags2.planPortLine ? 'porta' : 'nuevo',
      /** text indicating promotional text. For example, por 6 meses, luego $11990/mes */
      textoOferta: `por ${(_costs7 = costs) === null || _costs7 === void 0 ? void 0 : _costs7.termDuration} meses, luego $${((_costs8 = costs) === null || _costs8 === void 0 ? void 0 : _costs8.totalTermCost) / plansNums}/mes`,
      /** static text value. For example, na */
      Origen: 'recomendador',
      /** text indicating type of client. For example, Cliente */
      estadoCliente: appMetadata !== null && appMetadata !== void 0 && (_appMetadata$flags3 = appMetadata.flags) !== null && _appMetadata$flags3 !== void 0 && _appMetadata$flags3.isNotCustomer ? 'NoCliente' : appMetadata !== null && appMetadata !== void 0 && (_appMetadata$flags4 = appMetadata.flags) !== null && _appMetadata$flags4 !== void 0 && _appMetadata$flags4.isCustomer ? 'Cliente' : 'NoCliente'
    };
  }
  getCharacteristic(product, name) {
    var _product$selectedVari, _product$selectedVari2, _product$selectedVari3, _charValueArr$find;
    const charValueArr = product === null || product === void 0 ? void 0 : (_product$selectedVari = product.selectedVariant) === null || _product$selectedVari === void 0 ? void 0 : (_product$selectedVari2 = _product$selectedVari.characteristics) === null || _product$selectedVari2 === void 0 ? void 0 : (_product$selectedVari3 = _product$selectedVari2.find(c => c.id === name)) === null || _product$selectedVari3 === void 0 ? void 0 : _product$selectedVari3.value;
    return (charValueArr === null || charValueArr === void 0 ? void 0 : (_charValueArr$find = charValueArr.find(v => v.isDefault)) === null || _charValueArr$find === void 0 ? void 0 : _charValueArr$find.value) || (charValueArr === null || charValueArr === void 0 ? void 0 : charValueArr[0].value);
  }
  async addToCart(_ref3) {
    let {
      handsetProductId,
      handsetProduct,
      planProductId,
      costs,
      planProduct,
      appMetadata
    } = _ref3;
    // Sim only flow
    if (planProduct && !handsetProductId) {
      try {
        var _this$config, _this$config$devSetti;
        const payload = await this.composePlanPayload({
          planProduct,
          appMetadata,
          costs
        });
        const response = await _.http.post('/basket/cl/plan', payload);
        return (0, _utils.sendFormPostRequest)({
          ...response,
          target: (_this$config = this.config) !== null && _this$config !== void 0 && (_this$config$devSetti = _this$config.devSettings) !== null && _this$config$devSetti !== void 0 && _this$config$devSetti.openDeepLinksNewTab ? '_blank' : '_self'
        });
      } catch (error) {
        console.log('Cannot redirect url to plans basket', error);
      }
    }

    // handsets & plan
    if (handsetProduct) {
      var _handsetProduct$selec, _handsetProduct$selec2, _handsetProduct$selec3, _appMetadata$flags5, _costs$plan$variantId, _appMetadata$flags6, _costs$plan, _costs$plan$variantId2;
      const planQty = this.getPlanQty(planProduct, appMetadata);
      const prodId = this.getCharacteristic(handsetProduct, 'prodId');
      const handsetDiscount = handsetProduct === null || handsetProduct === void 0 ? void 0 : (_handsetProduct$selec = handsetProduct.selectedVariant) === null || _handsetProduct$selec === void 0 ? void 0 : (_handsetProduct$selec2 = _handsetProduct$selec.price.find(x => x.priceType === 'upfront')) === null || _handsetProduct$selec2 === void 0 ? void 0 : (_handsetProduct$selec3 = _handsetProduct$selec2.discount) === null || _handsetProduct$selec3 === void 0 ? void 0 : _handsetProduct$selec3.discountValue;
      const windowPayload = {
        type: 'equipment',
        id: handsetProductId,
        quantity: 1,
        displayPrice: appMetadata !== null && appMetadata !== void 0 && (_appMetadata$flags5 = appMetadata.flags) !== null && _appMetadata$flags5 !== void 0 && _appMetadata$flags5.isCustomer ? handsetDiscount : costs.handsetUpfrontCost,
        insurances: [],
        plan: costs.plan && !appMetadata.flags[_constants.ALTERNATIVE_RECOMMENDATION_FLAGS.ALTERNATIVE_PLANS_FLAG] ? {
          id: (_costs$plan$variantId = costs.plan.variantId) === null || _costs$plan$variantId === void 0 ? void 0 : _costs$plan$variantId.replace(/-PLANS(\d+)/, ''),
          isPortability: false,
          type: 'plan',
          quantity: parseInt(planQty)
        } : null,
        productId: prodId,
        origin: 'vodafone',
        discount: (!!(costs.plan || appMetadata !== null && appMetadata !== void 0 && (_appMetadata$flags6 = appMetadata.flags) !== null && _appMetadata$flags6 !== void 0 && _appMetadata$flags6.isCustomer)).toString(),
        origen: 'recomendador'
      };
      const postReqPayload = {
        productId: handsetProductId,
        quantityHandset: 1,
        planId: (costs === null || costs === void 0 ? void 0 : (_costs$plan = costs.plan) === null || _costs$plan === void 0 ? void 0 : (_costs$plan$variantId2 = _costs$plan.variantId) === null || _costs$plan$variantId2 === void 0 ? void 0 : _costs$plan$variantId2.replace(/-PLANS(\d+)/, '')) || null,
        quantityPlan: parseInt(planQty),
        clientType: this.isUserCustomer(appMetadata) ? 'Cliente' : 'NoCliente',
        saleType: planProductId ? 'nuevalinea' : 'equiposolo',
        productCode: prodId,
        origen: 'recomendador'
      };
      const {
        hostname
      } = window.location;
      const regex = new RegExp(this.WINDOW_FUNC_ROUTES.join('|'), 'i');
      if (regex.test(hostname) && window.vodafoneService) {
        return window.vodafoneService([windowPayload]).then(res => {
          var _this$config2, _this$config2$hostCon, _this$config3, _this$config3$devSett;
          console.log('Entel basket response', res);
          this.redirect({
            path: (_this$config2 = this.config) === null || _this$config2 === void 0 ? void 0 : (_this$config2$hostCon = _this$config2.hostContext) === null || _this$config2$hostCon === void 0 ? void 0 : _this$config2$hostCon.handsetBasketRedirectionPath,
            target: (_this$config3 = this.config) !== null && _this$config3 !== void 0 && (_this$config3$devSett = _this$config3.devSettings) !== null && _this$config3$devSett !== void 0 && _this$config3$devSett.openDeepLinksNewTab ? '_blank' : '_self'
          });
        }).catch(err => {
          console.log('Error: adding to basket', err);
        });
      }
      try {
        var _this$config4, _this$config4$devSett;
        console.log('Using basket/handsets');
        const response = await _.http.post('/basket/cl/handset', postReqPayload);
        return (0, _utils.sendFormPostRequest)({
          ...response,
          target: (_this$config4 = this.config) !== null && _this$config4 !== void 0 && (_this$config4$devSett = _this$config4.devSettings) !== null && _this$config4$devSett !== void 0 && _this$config4$devSett.openDeepLinksNewTab ? '_blank' : '_self'
        });
      } catch (error) {
        console.log('Cannot redirect url to handsets basket', error);
      }
    }
    return super.addToCart({
      handsetProductId,
      planProductId
    });
  }
}
var _default = HostServiceCL;
exports.default = _default;